import { render } from "./MySubjects.vue?vue&type=template&id=6df95e54"
import script from "./MySubjects.vue?vue&type=script&lang=js"
export * from "./MySubjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__